import moment from 'moment';
import appStorage from "./app-storage";

export const EMISSION_FRACTION_DIGITS = 2;

/** API returns emission/target values at 2dp; format only, never re-round. */
export const formatEmissionValue = (value: unknown): string => {
    const numeric = Number(value);
    if (value === null || value === undefined || value === "" || !Number.isFinite(numeric)) {
        return "-";
    }

    return numeric.toLocaleString(process.env.REACT_APP_LOCALE ?? "en-US", {
        minimumFractionDigits: EMISSION_FRACTION_DIGITS,
        maximumFractionDigits: EMISSION_FRACTION_DIGITS,
    });
};

export class Utilities {

    static isTokenExpired(): boolean {
      const timeLeftInExpiration = this.timeLeftInTokenExpiration();
      return timeLeftInExpiration <= 0;
    }

    static timeLeftInTokenExpiration(): number {
      const expireOn = appStorage.getExpirationTime();
      const timeNow = moment(new Date().toISOString());
      const expTime = moment(expireOn);
      const duration = moment.duration(expTime.diff(timeNow));
      return duration.asMinutes();
    }

    static redirectToLogout() {
      window.location.href = "/";
    }

    static triggerFileDownload(blob: Blob, filename: string): void {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }